import React, { useState, useEffect, useRef } from "react";
import { ProductForm } from "@shopify/theme-product-form";
import { getSizedImageUrl } from "@shopify/theme-images";
import { formatMoney } from "@shopify/theme-currency";
import { serialize } from "@utils";
import axios from "axios";

const CartUpsellItem = ({ product, layout, slider }) => {
  const ctx = window.theme_app;

  const formRef = useRef(null);
  const [productForm, setProductForm] = useState(null);

  const [currentVariant, setCurrentVariant] = useState(null);
  const [hasVariants, setHasVariants] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const onOptionChange = (e) => {
    setCurrentVariant(e.dataset.variant);
  };

  useEffect(() => {
    if (product) {
      setImageSrc(getSizedImageUrl(product.featured_image, "400x"));

      if (product.variants.length > 1) {
        setHasVariants(true);
      } else {
        setCurrentVariant(product.variants[0]);
      }
      ctx.emit("CartUpsellProductsLoaded");
      window.dispatchEvent(new Event("resize"));
    }
  }, [product]);

  useEffect(() => {
    if (formRef.current) {
      if (productForm) {
        productForm.destroy();
      }
      setProductForm(
        new ProductForm(formRef.current, product, {
          onOptionChange: onOptionChange,
        })
      );
    }
  }, [formRef.current]);

  const addProductToCart = (ev) => {
    ev.preventDefault();

    const formData = serialize(formRef.current);

    axios
      .post("/cart/add.js", formData)
      .then((response) => {
        ctx.emit("cart.update");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const renderTitle = () => {
    const titleArray = product.title.split("|");
    if (titleArray.length) {
      return (
        <h4 className="Card__title">
          <span>{titleArray[0]}</span>
          <small>{titleArray[1]}</small>
        </h4>
      );
    } else {
      return <h4 className="Card__title">{product.title}</h4>;
    }
  };
  const renderVariantOptions = () => {
    return (
      <>
        {product.options.map((option) => (
          <div className="optionWrapper" key={option.name}>
            <label htmlFor={`Option${option.position}`}>{option.name}</label>
            <select
              id={`Option${option.position}`}
              name={`options[${option.name}]`}
              defaultValue={"default"}
            >
              <option value="default">Select option</option>
              {option.values.map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </div>
        ))}
      </>
    );
  };

  return (
    <>
      {product ? (
        <div className="Slider__item">
          <div
            className="Card Card--cartUpsell Card--product"
            data-layout={layout}
          >
            <figure className="Card__media">
              <a href={product.url}>
                {imageSrc && (
                  <img src={imageSrc} loading="eager" alt={product.title} />
                )}
              </a>
            </figure>
            <div className="Card__details">
              <div className="title-price-wrapper">
                <a href={product.url}>{renderTitle()}</a>
                <div data-price-wrapper>
                  {product.price_varies && !currentVariant ? (
                    <span data-price-range>
                      {formatMoney(product.price_min)} -{" "}
                      {formatMoney(product.price_max)}
                    </span>
                  ) : null}

                  {currentVariant?.compare_at_price > currentVariant?.price ? (
                    <span data-compare-price>
                      {formatMoney(currentVariant.compare_at_price)}
                    </span>
                  ) : null}

                  {currentVariant || !product.price_varies ? (
                    <span data-product-price>
                      {currentVariant
                        ? formatMoney(currentVariant.price)
                        : formatMoney(product.price)}
                    </span>
                  ) : null}
                </div>
              </div>
              <form ref={formRef} onSubmit={addProductToCart}>
                {hasVariants && (
                  <div className="options">{renderVariantOptions()}</div>
                )}

                <input
                  hidden
                  type="number"
                  id="Quantity"
                  name="quantity"
                  defaultValue="1"
                  min="1"
                ></input>
                <input
                  hidden
                  name="id"
                  defaultValue={currentVariant?.id}
                ></input>

                <button
                  type="submit"
                  className="Button"
                  disabled={!currentVariant || !currentVariant.available}
                  data-style="solid purple"
                  data-layout="small"
                >
                  {!currentVariant
                    ? "Choose options"
                    : currentVariant.available
                    ? "Add to Cart"
                    : "Sold Out"}
                </button>
              </form>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
export default CartUpsellItem;
